module.exports = __webpack_public_path__ + "img/pinkSapphire@2x.71a2e3a.png";